import script from "./UploadLogoStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadLogoStep.vue?vue&type=script&setup=true&lang=ts"

import "./UploadLogoStep.vue?vue&type=style&index=0&id=2ef47c6f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ef47c6f"]])

export default __exports__